/**
 * Google Analytics loader
 */

require("./adapter")
require("./ga4/loader")
